import React from "react";
import { CatalogueLayout } from "../../../components/Layout/cardLayout";

export const CategoryOne = ({ data }) => {
  return (
    <div className="flex gap-4">
      <div className="flex-1">
        {" "}
        <CatalogueLayout title="Product Details" details={true}>
          <div className="flex flex-col">
            <div className="flex justify-between items-center py-1 pb-3 border-b border-b-[#E1E6E1] px-4">
              <p className="text-[#3E473F] text-sm font-semibold">Vendor</p>
              <p className="text-[#5F6D60] text-sm font-semibold">
                {data?.vendor?.name || "N/A"}
              </p>
            </div>
            <div className="flex justify-between items-center py-3 border-b border-b-[#E1E6E1] px-4">
              <p className="text-[#3E473F] text-sm font-semibold">
                Product Class
              </p>
              <p className="text-[#5F6D60] text-sm font-semibold">
                {" "}
                {data?.product_class || "N/A"}
              </p>
            </div>
            <div className="flex justify-between items-center py-3 border-b border-b-[#E1E6E1] px-4">
              <p className="text-[#3E473F] text-sm font-semibold">
                Active Ingredients
              </p>
              <p className="text-[#5F6D60] text-sm font-semibold">
                {" "}
                {data?.active_ingredient || "N/A"}
              </p>
            </div>
            <div className="flex justify-between items-center py-3 border-b border-b-[#E1E6E1] px-4">
              <p className="text-[#3E473F] text-sm font-semibold">Dose Rate</p>
              <p className="text-[#5F6D60] text-sm font-semibold">
                {" "}
                {data?.dose_rate || "N/A"}
              </p>
            </div>
            <div className="flex justify-between items-center pt-3 px-4">
              <p className="text-[#3E473F] text-sm font-semibold w-[40%]">
                Target Crops
              </p>
              <div className="w-[60%] flex justify-end  items-end">
                {data?.target_crops?.length === 0 ? (
                  <p className="text-[#5F6D60] text-sm font-semibold">N/A</p>
                ) : (
                  <div className="flex items-center flex-wrap gap-2">
                    {data?.target_crops?.map((crop, index) => (
                      <div
                        key={index}
                        className=" rounded-[4px] px-1  bg-white py-[2px] border border-[#E1E6E1]"
                      >
                        <p className="text-[#5F6D60]  text-sm font-semibold">
                          {crop?.name || "N/A"}
                        </p>
                      </div>
                    ))}
                  </div>
                )}
              </div>
            </div>
          </div>
        </CatalogueLayout>
      </div>
      <div className="flex-1">
        <div className="flex flex-col gap-2">
          {" "}
          <CatalogueLayout
            title=" Application Time"
            description={data?.time_of_application || "N/A"}
          />{" "}
          <CatalogueLayout
            title="Mixing And Application"
            description={data?.mixing_and_application || "N/A"}
          />
        </div>
      </div>
    </div>
  );
};

export const CategoryTwo = ({ data }) => {
  return (
    <div className="flex gap-4">
      <div className="flex-1">
        {" "}
        <CatalogueLayout title="Product Details" details={true}>
          <div className="flex flex-col">
            <div className="flex justify-between items-center py-1 pb-3 border-b border-b-[#E1E6E1] px-4">
              <p className="text-[#3E473F] text-sm font-semibold">Vendor</p>
              <p className="text-[#5F6D60] text-sm font-semibold">
                {data?.vendor?.name || "N/A"}
              </p>
            </div>
            <div className="flex justify-between items-center py-3 border-b border-b-[#E1E6E1] px-4">
              <p className="text-[#3E473F] text-sm font-semibold">
                Product Class
              </p>
              <p className="text-[#5F6D60] text-sm font-semibold">
                {" "}
                {data?.product_class || "N/A"}
              </p>
            </div>
            <div className="flex justify-between items-center py-3 border-b border-b-[#E1E6E1] px-4">
              <p className="text-[#3E473F] text-sm font-semibold">
                Active Ingredients
              </p>
              <p className="text-[#5F6D60] text-sm font-semibold">
                {" "}
                {data?.active_ingredient || "N/A"}
              </p>
            </div>
            <div className="flex justify-between items-center py-3 border-b border-b-[#E1E6E1] px-4">
              <p className="text-[#3E473F] text-sm font-semibold">Dose Rate</p>
              <p className="text-[#5F6D60] text-sm font-semibold">
                {" "}
                {data?.dose_rate || "N/A"}
              </p>
            </div>

            <div className="flex justify-between items-center pt-3 px-4">
              <p className="text-[#3E473F] text-sm font-semibold w-[40%]">
                Target Crops
              </p>
              <div className="w-[60%] flex justify-end items-end">
                {data?.target_crops?.length === 0 ? (
                  <p className="text-[#5F6D60] text-sm font-semibold">N/A</p>
                ) : (
                  <div className="flex items-center gap-2">
                    {data?.target_crops?.map((crop, index) => (
                      <div
                        key={index}
                        className=" rounded-[4px] px-1 bg-white py-[2px] border border-[#E1E6E1]"
                      >
                        <p className="text-[#5F6D60]  text-sm font-semibold">
                          {crop?.name || "N/A"}
                        </p>
                      </div>
                    ))}
                  </div>
                )}
              </div>
            </div>
          </div>
        </CatalogueLayout>
      </div>
      <div className="flex-1">
        <div className="flex flex-col gap-2">
          <CatalogueLayout
            title="Mixing And Application"
            description={data?.mixing_and_application || "N/A"}
          />
        </div>
      </div>
    </div>
  );
};

export const CategoryThree = ({ data }) => {
  return (
    <div className="flex gap-4">
      <div className="flex-1">
        {" "}
        <CatalogueLayout title="Product Details" details={true}>
          <div className="flex flex-col">
            <div className="flex justify-between items-center py-1 pb-3 border-b border-b-[#E1E6E1] px-4">
              <p className="text-[#3E473F] text-sm font-semibold">Vendor</p>
              <p className="text-[#5F6D60] text-sm font-semibold">
                {data?.vendor?.name || "N/A"}
              </p>
            </div>
            <div className="flex justify-between items-center py-3 border-b border-b-[#E1E6E1] px-4">
              <p className="text-[#3E473F] text-sm font-semibold">
                Composition
              </p>
              <p className="text-[#5F6D60] text-sm font-semibold">
                {" "}
                {data?.composition || "N/A"}
              </p>
            </div>
            <div className="flex justify-between items-center py-3 border-b border-b-[#E1E6E1] px-4">
              <p className="text-[#3E473F] text-sm font-semibold">Dose Rate</p>
              <p className="text-[#5F6D60] text-sm font-semibold">
                {" "}
                {data?.dose_rate || "N/A"}
              </p>
            </div>
            <div className="flex justify-between items-center pt-3 px-4  py-3 border-b border-b-[#E1E6E1]">
              <p className="text-[#3E473F] text-sm font-semibold">
                Rate Of Use
              </p>
              <p className="text-[#5F6D60] text-sm font-semibold">
                {" "}
                {data?.use_rate || "N/A"}
              </p>
            </div>
            <div className="flex justify-between items-center pt-3 px-4">
              <p className="text-[#3E473F] text-sm font-semibold w-[40%]">
                Target Crops
              </p>
              <div className="w-[60%] flex justify-end items-end">
                {data?.target_crops?.length === 0 ? (
                  <p className="text-[#5F6D60] text-sm font-semibold">N/A</p>
                ) : (
                  <div className="flex items-center gap-2">
                    {data?.target_crops?.map((crop, index) => (
                      <div
                        key={index}
                        className=" rounded-[4px] px-1 bg-white py-[2px] border border-[#E1E6E1]"
                      >
                        <p className="text-[#5F6D60]  text-sm font-semibold">
                          {crop?.name || "N/A"}
                        </p>
                      </div>
                    ))}
                  </div>
                )}
              </div>
            </div>
          </div>
        </CatalogueLayout>
      </div>
      <div className="flex-1">
        <div className="flex flex-col gap-2">
          <CatalogueLayout
            title="Mode of Action"
            description={data?.mode_of_action || "N/A"}
          />
        </div>
      </div>
    </div>
  );
};

export const CategoryFour = ({ data }) => {
  return (
    <div className="flex gap-4">
      <div className="flex-1">
        {" "}
        <CatalogueLayout title="Product Details" details={true}>
          <div className="flex flex-col">
            <div className="flex justify-between items-center py-1 pb-3 border-b border-b-[#E1E6E1] px-4">
              <p className="text-[#3E473F] text-sm font-semibold">Vendor</p>
              <p className="text-[#5F6D60] text-sm font-semibold">
                {data?.vendor?.name || "N/A"}
              </p>
            </div>
            <div className="flex justify-between items-center py-3 border-b border-b-[#E1E6E1] px-4">
              <p className="text-[#3E473F] text-sm font-semibold">
                Active Ingredients
              </p>
              <p className="text-[#5F6D60] text-sm font-semibold">
                {" "}
                {data?.active_ingredient || "N/A"}
              </p>
            </div>
            <div className="flex justify-between items-center py-3 border-b border-b-[#E1E6E1] px-4">
              <p className="text-[#3E473F] text-sm font-semibold">Dose Rate</p>
              <p className="text-[#5F6D60] text-sm font-semibold">
                {" "}
                {data?.dose_rate || "N/A"}
              </p>
            </div>

            <div className="flex justify-between items-center pt-3 px-4">
              <p className="text-[#3E473F] text-sm font-semibold w-[40%]">
                Target Crops
              </p>
              <div className="w-[60%] flex justify-end items-end">
                {data?.target_crops?.length === 0 ? (
                  <p className="text-[#5F6D60] text-sm font-semibold">N/A</p>
                ) : (
                  <div className="flex items-center gap-2">
                    {data?.target_crops?.map((crop, index) => (
                      <div
                        key={index}
                        className=" rounded-[4px] px-1 bg-white py-[2px] border border-[#E1E6E1]"
                      >
                        <p className="text-[#5F6D60]  text-sm font-semibold">
                          {crop?.name || "N/A"}
                        </p>
                      </div>
                    ))}
                  </div>
                )}
              </div>
            </div>
          </div>
        </CatalogueLayout>
      </div>
      <div className="flex-1">
        <div className="flex flex-col gap-2">
          <CatalogueLayout
            title="Mixing And Application"
            description={data?.mixing_and_application || "N/A"}
          />
        </div>
      </div>
    </div>
  );
};

export const CategoryFive = ({ data }) => {
  return (
    <div className="flex gap-4">
      <div className="flex-1">
        {" "}
        <CatalogueLayout title="Product Details" details={true}>
          <div className="flex flex-col">
            <div className="flex justify-between items-center py-1 pb-3 border-b border-b-[#E1E6E1] px-4">
              <p className="text-[#3E473F] text-sm font-semibold">Vendor</p>
              <p className="text-[#5F6D60] text-sm font-semibold">
                {data?.vendor?.name || "N/A"}
              </p>
            </div>
            <div className="flex justify-between items-center pt-3 px-4">
              <p className="text-[#3E473F] text-sm font-semibold">Seed Rate</p>
              <p className="text-[#5F6D60] text-sm font-semibold">
                {" "}
                {data?.seed_rate || "N/A"}
              </p>
            </div>
          </div>
        </CatalogueLayout>
      </div>
      <div className="flex-1">
        <div className="flex flex-col gap-2">
          {" "}
          <CatalogueLayout
            title="Adaptability"
            description={data?.adaptability || "N/A"}
          />{" "}
          <CatalogueLayout
            title="Requirements"
            description={data?.requirements || "N/A"}
          />
        </div>
      </div>
    </div>
  );
};
